import React, { useEffect, useRef, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FaCheck } from "react-icons/fa"
import { GrPowerReset, GrClearOption } from "react-icons/gr"

import RoiDrawCanvas from './RoiDrawCanvas'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import { showError } from 'Shared/Components/NotifyToast'
import { Stack } from '@mui/material'
import { IconButtonComponent } from 'Shared/Components/Icon'
import PopupModal from 'Shared/Components/PopupModal'

const RoiDrawModal = ({ camera_id, toggle, roi, onRoiChange }) => {
  const { t } = useTranslation()
  const { send } = useFetchData()

  const [image, setImage] = useState()
  const [finished, setFinished] = useState(false)
  const [roiModalOpen, setRoiModalOpen] = useState()
  const { setPageLoading } = useOutletContext()

  const mapRef = useRef()

  useEffect(() => {
    const getSnapshot = async () => {
      setPageLoading(true)

      const body = await send({
        method: "GET",
        url: `${apiUrl}/camera/snapshot`,
        params: {
          "camera_id": camera_id
        },
        returnType: "json"
      })
  
      if (body == null) {
        showError(t("cameras_errorConnectingToCamera"))
        setPageLoading(false)
        return
      }
  
      setImage(body)

      setRoiModalOpen(true)
      setPageLoading(false)
    }

    const init = async () => {
      await Promise.all([
        getSnapshot()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const reset = () => {
    mapRef.current.reset()
  }

  const clear = () => {
    mapRef.current.clear()
  }

  const update = async () => {
    let area = await mapRef.current.getCoordinates()
    area = area.map((i) => [parseFloat(i[0].toFixed(5)), parseFloat(i[1].toFixed(5))])

    onRoiChange({
      "area": area,
      "snapshot": image["image"]
    })

    toggle()
  }

  return (<>
    <PopupModal isOpen={roiModalOpen} close toggle={() => toggle()} width="80%" height="80%">
      <div style={{ height: "100%", width: "100%", display: "flex", flexFlow: "column" }}>    
        <div style={{ flexGrow: 1, overflow: "auto" }}>
          {image && 
            <RoiDrawCanvas
              mode={(roi.length > 0) ? "Modify" : "Draw"} ref={mapRef}
              snapshot={image} area={roi ?? []} setFinishState={(finished) => setFinished(finished)}
            />
          }
        </div>

        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
          <div></div>
          
          <Stack direction="row" spacing={2}>
            <IconButtonComponent title={t("camera_roiApply")} onClick={() => update()}>
              <FaCheck />
            </IconButtonComponent>

            <IconButtonComponent title={t("camera_roiReset")} onClick={() => reset()}>
              <GrPowerReset />
            </IconButtonComponent>

            <IconButtonComponent title={t("camera_roiClear")} onClick={() => clear()}>
              <GrClearOption />
            </IconButtonComponent>
          </Stack>
        </div>
      </div>
    </PopupModal>
  </>)
}

export default RoiDrawModal